import type { AppRouter } from "@eurostorm/api/routers";
import { createTRPCReact } from "@trpc/react-query";

/**
 * Cliente tRPC tipado pelo AppRouter do backend.
 * Hooks de React Query gerados automaticamente: `trpc.health.ping.useQuery()`, etc.
 */
export const trpc = createTRPCReact<AppRouter>();

export type { AppRouter };
